var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',_vm._g(_vm._b({staticClass:"ledger-modal"},'Modal',_vm.$attrs,false),_vm.$listeners),[_vm._l((Object.keys(_vm.$slots)),function(slot){return _vm._t(slot,null,{"slot":slot})}),_c('img',{attrs:{"slot":"logo","src":require("../../assets/ledger-logo.svg")},slot:"logo"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }